// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j7aaU","label":"styles_label__QuWPI"};